// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-167By";
var _4 = "selectedFlights-1Sjk2";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "selectedFlights" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "selectedFlights": _4 }
